import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m10.363 4.457-8.106 14.06a2.05 2.05 0 0 0-.006 1.98c.166.3.404.552.692.728.289.176.616.271.95.275h16.214a1.86 1.86 0 0 0 .95-.275c.288-.176.526-.427.692-.729a2.05 2.05 0 0 0-.005-1.979l-8.107-14.06a1.95 1.95 0 0 0-.698-.701 1.86 1.86 0 0 0-1.878 0 1.95 1.95 0 0 0-.698.701"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#6C6C6B",
      "fill-rule": "evenodd",
      d: "M11 17.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#6C6C6B",
      "stroke-linecap": "round",
      "stroke-width": "2",
      d: "M12 13.5v-4"
    }, null, -1)
  ]))]))
}
export default { render: render }